import { StoreItem } from '../Store';
import { TagDefinitionDTO, TagDefinition } from '../../models/';
import ReducerCreator from '../registerReducer';
import * as Actions from './tags.constants';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';


const r = new ReducerCreator<TagDefinitionDTO>()
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<TagDefinitionDTO>();
    })
    .register<TagDefinitionDTO[]>(Actions.TAGS_LOAD, (state, payload) => {
        const newState = copyTagsDefinitionsDtoStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<TagDefinitionDTO[]>(Actions.TAG_LOAD, (state, payload) => {
        const newState = copyTagsDefinitionsDtoStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<TagDefinitionDTO[]>(Actions.TAGS_DTO_LOAD_SUCCESS, (state, payload) => {
        return buildTagsDefinitionsDtoStoreItem(payload);
    })
    .register<TagDefinitionDTO>(Actions.TAG_DTO_LOAD_SUCCESS, (state, payload) => {
        const newItem = copyTagsDefinitionsDtoStoreItem(state.dictionary);
        newItem.dictionary[payload.tagDefinition.guid] = payload;
        return newItem;
    })
    .register<TagDefinitionDTO[]>(Actions.TAGS_DTO_UPDATE_SUCCESS, (state, payload) => {
        const newItem = copyTagsDefinitionsDtoStoreItem(state.dictionary);
        payload.forEach(t => newItem.dictionary[t.tagDefinition.guid] = t);
        return newItem;
    })
    .register<TagDefinition[]>(Actions.TAGS_DELETE_SUCCESS, (state, payload) => {
        const newItem = copyTagsDefinitionsDtoStoreItem(state.dictionary);
        payload.forEach(t => delete newItem.dictionary[t.guid]);
        return newItem;
    });


export function tagsDtoReducer(
    state: StoreItem<TagDefinitionDTO> = new StoreItem<TagDefinitionDTO>(),
    action: { type: string, payload: any }
) {
    return r.reduce(state, action);
}

function copyTagsDefinitionsDtoStoreItem(dictionary: { [guid: string]: TagDefinitionDTO }): StoreItem<TagDefinitionDTO> {
    const dic = {};
    Object.keys(dictionary).forEach(k => dic[k] = dictionary[k]);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}

function buildTagsDefinitionsDtoStoreItem(payload: TagDefinitionDTO[]): StoreItem<TagDefinitionDTO> {
    const dic = {};
    payload.forEach(element => {
        dic[element.tagDefinition.guid] = element;
    });
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}